// src/components/Footer.jsx
import React from 'react';
import './Footer.css'; // optional: move footer styles here

const Footer = () => (
  <footer id="footer" aria-label="Footer Information">
    <div>

      <p>&copy; Sudhamshu Ayurveda. All rights reserved.</p>
      <p><strong>Online Consultation-</strong> Morning 10:30am- 1pm, Evening 5pm-7:30pm</p>
      <p><strong>Offline/ In-clinic Consultation-</strong>Morning 10:30am- 2pm; </p>
      <p><strong>Weekends on prior appointments only</strong></p>
      <p>
        Contact us: <a href="mailto:contact@ayurclinic.com">sudhamshu.ayurveda@gmail.com</a> | Phone: +91 74066 80614
      </p>


    </div>
    <div>
      <p>Follow us:</p>
      <div className="socials" role="list">
        {/* Facebook */}
        <a href="https://www.facebook.com/share/1EvTWrhJeY/" aria-label="Facebook" title="Facebook">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
            <path d="M22.675 0h-21.35C.595 0 0 .6 0 1.333v21.334C0 23.4.595 24 1.325 24h11.494v-9.294H9.691V11.02h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.462.099 2.795.143v3.24h-1.918c-1.504 0-1.796.715-1.796 1.763v2.31h3.59l-.467 3.685h-3.123V24h6.116c.73 0 1.325-.6 1.325-1.333V1.333C24 .6 23.405 0 22.675 0z" />
          </svg>

        </a>
        {/* LinkedIn*/}
        <a href="https://www.linkedin.com/in/dr-vaishnavi-km-64808b224?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" aria-label="LinkedIn" title="LinkedIn">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
            <path d="M20.447 20.452H16.9v-5.569c0-1.328-.025-3.037-1.852-3.037-1.853 0-2.136 1.447-2.136 2.939v5.667H9.365V9h3.4v1.561h.048c.474-.9 1.637-1.852 3.372-1.852 3.605 0 4.271 2.372 4.271 5.455v6.288zM5.337 7.433a1.97 1.97 0 110-3.94 1.97 1.97 0 010 3.94zM6.957 20.452H3.716V9h3.241v11.452z" />
          </svg>
        </a>


        {/* Instagram */}
        <a href="https://www.instagram.com/sudhamshu.ayurveda?igsh=cXJzODJwYXY5dDk2" aria-label="Instagram" title="Instagram">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
            <path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.055 1.97.25 2.427.415a4.92 4.92 0 0 1 1.78 1.03 4.92 4.92 0 0 1 1.03 1.78c.165.457.36 1.257.415 2.427.058 1.266.07 1.65.07 4.85s-.012 3.584-.07 4.85c-.055 1.17-.25 1.97-.415 2.427a4.92 4.92 0 0 1-1.03 1.78 4.92 4.92 0 0 1-1.78 1.03c-.457.165-1.257.36-2.427.415-1.266.058-1.65.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.055-1.97-.25-2.427-.415a4.92 4.92 0 0 1-1.78-1.03 4.92 4.92 0 0 1-1.03-1.78c-.165-.457-.36-1.257-.415-2.427C2.212 15.784 2.2 15.4 2.2 12s.012-3.584.07-4.85c.055-1.17.25-1.97.415-2.427a4.92 4.92 0 0 1 1.03-1.78 4.92 4.92 0 0 1 1.78-1.03c.457-.165 1.257-.36 2.427-.415C8.416 2.212 8.8 2.2 12 2.2zm0-2.2C8.736 0 8.332.013 7.052.072 5.776.13 4.745.342 3.943.648 3.1.968 2.39 1.41 1.71 2.09.68 3.12.13 4.548.07 7.052.013 8.332 0 8.736 0 12s.013 3.668.072 4.948c.058 2.504.608 3.932 1.638 4.962.68.68 1.09 1.39 2.22 1.72.8.306 1.83.518 3.107.577 1.28.058 1.684.072 4.948.072s3.668-.013 4.948-.072c2.504-.058 3.932-.608 4.962-1.638.68-.68 1.09-1.39 1.72-2.22.306-.8.518-1.83.577-3.107.058-1.28.072-1.684.072-4.948s-.013-3.668-.072-4.948c-.058-2.504-.608-3.932-1.638-4.962C21.61 1.41 20.9.97 20.222.64 19.42.333 18.39.122 17.112.063 15.832.004 15.428 0 12 0zM12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.16a3.998 3.998 0 1 1 0-7.996 3.998 3.998 0 0 1 0 7.996zm6.406-11.162a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z" />
          </svg>

        </a>
        {/* Youtube */}
        <a href="https://youtube.com/@sudhamshuayurveda?si=m8V9lXQ0kwjzRA3L" aria-label="YouTube" title="YouTube">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">
            <path d="M23.498 6.186a2.974 2.974 0 00-2.093-2.103C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.405.583a2.974 2.974 0 00-2.093 2.103A31.537 31.537 0 000 12a31.537 31.537 0 00.502 5.814 2.974 2.974 0 002.093 2.103C4.495 20.5 12 20.5 12 20.5s7.505 0 9.405-.583a2.974 2.974 0 002.093-2.103A31.537 31.537 0 0024 12a31.537 31.537 0 00-.502-5.814zM9.75 15.02V8.98l6.5 3.02-6.5 3.02z" />
          </svg>
        </a>

      </div>
    </div>
  </footer>
);

export default Footer;
